import React from 'react';

const DocumentosGeradosTable = ({
  documentosGerados,
  loadingDocumentos,
  menuAberto,
  setMenuAberto,
  abrirDialogVerTexto,
  abrirDialogAlterar,
  downloadDocx,
  formatarData
}) => {
  return (
    <div className="documentos-gerados-section">
      <h3>📂 Documentos Gerados</h3>
      {loadingDocumentos ? (
        <div className="loading-documentos">Carregando documentos...</div>
      ) : documentosGerados.length === 0 ? (
        <div className="sem-documentos">Nenhum documento gerado ainda.</div>
      ) : (
        <table className="documentos-table">
          <thead>
            <tr>
              <th>Data/Hora</th>
              <th>Origem</th>
              <th>Ficheiro</th>
              <th>Caso Associado</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {documentosGerados.map((doc) => (
              <tr key={doc.id}>
                <td>{formatarData(doc.created_at)}</td>
                <td>{doc.origem}</td>
                <td>{doc.file_name}</td>
                <td>{doc.caso_nome || '-'}</td>
                <td>
                  <div className="menu-acoes-container">
                    <button
                      className="btn-menu-acoes"
                      onClick={() => setMenuAberto(menuAberto === doc.id ? null : doc.id)}
                    >
                      ⋮
                    </button>
                    {menuAberto === doc.id && (
                      <div className="menu-acoes-dropdown">
                        <button onClick={() => abrirDialogVerTexto(doc)}>👁️ Ver Texto</button>
                        <button onClick={() => abrirDialogAlterar(doc)}>✏️ Alterar Documento</button>
                        <button onClick={() => downloadDocx(doc)}>💾 Download .DOCX</button>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default DocumentosGeradosTable;
